import React from 'react';
import { 
  Box, 
  Typography, 
  Avatar, 
  Button 
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

const EmptyCallCard = ({ 
  title = "No Recent Calls", 
  description = "No call records found for this lead. Start tracking communication by logging your first call.",
  compact = false 
}) => {
  return (
    <Box sx={{ 
      p: compact ? 2.5 : 4, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 120 : 200
    }}>
      <Avatar 
        sx={{ 
          bgcolor: 'rgba(33, 150, 243, 0.1)', 
          color: 'primary.main', 
          width: compact ? 40 : 56, 
          height: compact ? 40 : 56,
          margin: '0 auto',
          mb: compact ? 1.5 : 2,
          boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)'
        }}
      >
        <PhoneIcon sx={{ fontSize: compact ? 20 : 28 }} />
      </Avatar>
      
      <Typography 
        variant={compact ? "subtitle1" : "h6"} 
        color="text.primary" 
        sx={{ 
          fontWeight: 600, 
          mb: compact ? 0.5 : 1,
          fontSize: compact ? '0.875rem' : '1.125rem'
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body2" 
        color="text.secondary" 
        sx={{ 
          lineHeight: 1.6, 
          mb: compact ? 1.5 : 2,
          fontSize: compact ? '0.813rem' : '0.875rem',
          maxWidth: 300
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyCallCard; 